import { render } from "./DespesaGrupoSelect.vue?vue&type=template&id=ac4dfe54"
import script from "./DespesaGrupoSelect.vue?vue&type=script&lang=js"
export * from "./DespesaGrupoSelect.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__